// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index/js/" + chunkId + "." + "81808adf" + ".js";
};